var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_1433)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2396_1433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2315 121.32C67.1912 126.496 68.3162 131.635 69.7719 136.68C60.4173 131.943 52.7731 124.254 47.988 114.895C53.0279 116.351 58.1928 117.507 63.345 118.447C64.8101 118.715 65.9603 119.857 66.2315 121.32Z",
    fill: "url(#paint0_linear_2396_1433)",
    stroke: "url(#paint1_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.904 114.6C136.904 114.6 136.904 114.601 136.903 114.603C136.904 114.601 136.904 114.6 136.904 114.6ZM121.461 118.443C126.625 117.502 131.725 116.344 136.76 114.886C133.162 121.978 127.875 128.088 121.452 132.733C120.236 133.613 118.927 133.453 117.993 132.721C117.047 131.981 116.478 130.645 116.846 129.151C117.484 126.563 118.055 123.967 118.542 121.361C118.82 119.877 119.98 118.713 121.461 118.443Z",
    fill: "url(#paint2_linear_2396_1433)",
    stroke: "url(#paint3_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.76 63.2688C133.638 64.4846 133.476 65.7928 132.742 66.7273C131.999 67.6732 130.661 68.2425 129.167 67.8762C126.608 67.2484 124.037 66.684 121.451 66.1894C119.975 65.9072 118.821 64.7446 118.547 63.266C118.074 60.7161 117.526 58.1766 116.909 55.6534C116.541 54.1509 117.115 52.7989 118.068 52.0477C119.009 51.3058 120.324 51.1409 121.543 52.0254C125.855 55.1528 129.643 58.9491 132.76 63.2688Z",
    fill: "url(#paint4_linear_2396_1433)",
    stroke: "url(#paint5_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.791 47.9787C68.3337 53.0174 67.2082 58.1201 66.2768 63.2849C66.0082 64.7747 64.8307 65.9394 63.3345 66.2113C60.7369 66.6832 58.1486 67.2446 55.5696 67.8758C54.0746 68.2417 52.7376 67.6715 51.9972 66.7256C51.2657 65.791 51.1055 64.4823 51.9853 63.2658C56.6215 56.8553 62.7164 51.5763 69.791 47.9787Z",
    fill: "url(#paint6_linear_2396_1433)",
    stroke: "url(#paint7_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.393 44.8303L80.3997 44.8105L80.4048 44.7903C80.546 44.2253 80.8265 43.8841 81.2149 43.7975C84.8211 42.994 88.5096 42.5 92.3582 42.5C96.1559 42.5 99.8764 42.9926 103.446 43.7939C103.859 43.8864 104.177 44.2505 104.312 44.7903L104.317 44.81L104.323 44.8292C106.003 49.793 107.322 54.8433 108.405 59.9402C108.888 62.2125 106.98 64.2915 104.617 64.1079C96.4556 63.4739 88.2608 63.4739 80.0999 64.1079C77.7367 64.2915 75.8286 62.2125 76.3102 59.9396C77.3934 54.8282 78.7131 49.7579 80.393 44.8303Z",
    fill: "url(#paint8_linear_2396_1433)",
    stroke: "url(#paint9_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8303 104.323L44.8105 104.317L44.7903 104.312C44.2253 104.17 43.8841 103.89 43.7975 103.502C42.994 99.8954 42.5 96.2069 42.5 92.3582C42.5 88.5606 42.9926 84.84 43.7939 81.2701C43.8864 80.8578 44.2505 80.5398 44.7903 80.4048L44.8083 80.4003L44.826 80.3944C49.8101 78.7456 54.8516 77.4041 59.9718 76.3077C62.2342 75.8232 64.3059 77.717 64.1296 80.0722C63.5171 88.2515 63.5171 96.4649 64.1296 104.644C64.3059 106.999 62.2339 108.896 59.9688 108.417C54.8341 107.332 49.7745 106.009 44.8303 104.323Z",
    fill: "url(#paint10_linear_2396_1433)",
    stroke: "url(#paint11_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.928 104.312L139.91 104.316L139.892 104.322C134.925 105.965 129.872 107.303 124.775 108.398C122.505 108.885 120.426 106.98 120.61 104.617C121.244 96.4556 121.244 88.2608 120.61 80.0999C120.426 77.7367 122.505 75.8286 124.778 76.3102C129.89 77.3934 134.96 78.7131 139.888 80.393L139.907 80.3997L139.928 80.4048C140.45 80.5353 140.833 80.874 140.922 81.2719C141.725 84.8759 142.218 88.558 142.218 92.3582C142.218 96.2069 141.724 99.8954 140.92 103.502C140.834 103.89 140.493 104.17 139.928 104.312Z",
    fill: "url(#paint12_linear_2396_1433)",
    stroke: "url(#paint13_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.323 139.886L104.317 139.906L104.312 139.926C104.177 140.466 103.859 140.83 103.446 140.923C99.8764 141.724 96.1559 142.216 92.3582 142.216C88.5096 142.216 84.8211 141.723 81.2149 140.919L81.1061 141.407L81.2149 140.919C80.8265 140.832 80.546 140.491 80.4048 139.926L80.4003 139.908L80.3944 139.89C78.7481 134.914 77.4082 129.88 76.3126 124.768C75.8264 122.499 77.7303 120.431 80.0855 120.636C84.1597 120.99 88.2454 121.21 92.3582 121.21C96.4617 121.21 100.562 120.991 104.626 120.638C106.983 120.433 108.892 122.503 108.411 124.776C107.327 129.901 106.006 134.951 104.323 139.886Z",
    fill: "url(#paint14_linear_2396_1433)",
    stroke: "url(#paint15_linear_2396_1433)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.169 108.174C111.003 109.756 109.756 111.003 108.174 111.169C97.653 112.279 87.0633 112.279 76.5422 111.169C74.9605 111.003 73.7137 109.756 73.5469 108.174C72.4375 97.653 72.4375 87.0633 73.5469 76.5422C73.7137 74.9605 74.9605 73.7137 76.5422 73.5469C87.0633 72.4375 97.653 72.4375 108.174 73.5469C109.756 73.7137 111.003 74.9605 111.169 76.5422C112.279 87.0633 112.279 97.653 111.169 108.174Z",
    fill: "url(#paint16_linear_2396_1433)",
    stroke: "url(#paint17_linear_2396_1433)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2396_1433",
    x: 12.6764,
    y: 35.6764,
    width: 159.366,
    height: 159.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6618
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.913725 0 0 0 0 0.878431 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2396_1433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2396_1433",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.773148 0 0 0 0 0.833333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2396_1433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2396_1433",
    x1: 47.102,
    y1: 115.271,
    x2: 95.9649,
    y2: 156.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2396_1433",
    x1: 58.8951,
    y1: 114.213,
    x2: 58.8951,
    y2: 137.328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2396_1433",
    x1: 113.724,
    y1: 115.292,
    x2: 163.492,
    y2: 157.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2396_1433",
    x1: 125.671,
    y1: 114.213,
    x2: 125.671,
    y2: 137.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2396_1433",
    x1: 113.72,
    y1: 48.0253,
    x2: 164.073,
    y2: 90.7712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2396_1433",
    x1: 125.873,
    y1: 46.9351,
    x2: 125.873,
    y2: 70.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2396_1433",
    x1: 46.6975,
    y1: 48.4102,
    x2: 96.2332,
    y2: 90.6429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2396_1433",
    x1: 58.6961,
    y1: 47.3384,
    x2: 58.6961,
    y2: 70.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2396_1433",
    x1: 74.4245,
    y1: 43.058,
    x2: 122.372,
    y2: 104.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2396_1433",
    x1: 92.3582,
    y1: 42,
    x2: 92.3582,
    y2: 65.1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2396_1433",
    x1: 41.7641,
    y1: 76.392,
    x2: 105.865,
    y2: 112.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2396_1433",
    x1: 53.5572,
    y1: 74.7832,
    x2: 53.5572,
    y2: 109.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2396_1433",
    x1: 119.368,
    y1: 76.392,
    x2: 183.468,
    y2: 112.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2396_1433",
    x1: 131.161,
    y1: 74.7832,
    x2: 131.161,
    y2: 109.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2396_1433",
    x1: 74.4245,
    y1: 120.66,
    x2: 122.372,
    y2: 182.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2396_1433",
    x1: 92.3582,
    y1: 119.602,
    x2: 92.3582,
    y2: 142.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2396_1433",
    x1: 71.8038,
    y1: 74.0588,
    x2: 156.968,
    y2: 146.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46E7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EE7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2396_1433",
    x1: 92.3581,
    y1: 72.2148,
    x2: 92.3581,
    y2: 112.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_1433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeb);
export default __webpack_public_path__ + "static/media/IconWeb.9354c606aae828cbf5ae36aebaa0c5d3.svg";
export { ForwardRef as ReactComponent };